import { render } from "./legoPagination.vue?vue&type=template&id=6cb45190"
import script from "./legoPagination.vue?vue&type=script&lang=js"
export * from "./legoPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoPagination/legoPagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cb45190"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cb45190', __exports__)) {
    api.reload('6cb45190', __exports__)
  }
  
  module.hot.accept("./legoPagination.vue?vue&type=template&id=6cb45190", () => {
    api.rerender('6cb45190', render)
  })

}


export default __exports__